module.exports = __webpack_public_path__ + "static/media/plane.35701432.png";